<template>
  <div>
    <login @loginaction="updatelogin" v-if="!canlogin"></login>

    <mainScreen @loginaction="updatelogin" v-if="canlogin"></mainScreen>
  </div>
</template>

<script >
import login from './login';
import mainScreen from './main';

export default {
    watch: {
    },
    data() {
        return {
            canlogin:this.$store.getters.cardLogged
        }
    },
    mounted() {
      console.log(this.$store)
      this.canlogin = this.$store.getters.cardLogged
    },
    components: {
        login,
        mainScreen
    },
    methods:{
      updatelogin(newvalue) {
        this.canlogin = newvalue;
      }
    }
}
</script>

<style>

</style>